export const SUBMIT_NPS = 'SUBMIT_NPS';
export const SUBMIT_NPS_ON_EXIT = 'SUBMIT_NPS_ON_EXIT';
export const NPS_RETRY = 'NPS_RETRY';
